export class FormRequest {
  title = "";
  firstName = "";
  lastName = "";
  email = "";
  confirmMail = "";
  idProfession: number | null = null;
  idSpecialite: number | null = null;
  nationalId = "";
  phone = "";
  mobilePhone = "";
  comment = "";
  login = "";
  password = "";
  confirmPassword = "";
  CGU = false;
  validData = false;
  newsletter = false;

  additionalFields: { [key: string]: string } = {};
  attachmentFields: { [key: string]: File } = {};
  additionalCheckboxes: { [key: string]: string } = {};
}
